import Icon from '../components/Icon.vue'

Icon.register({
  fill: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 217.1c12.5 12.5 12.5 32.8 0 45.3l-221.6 221.6c-18.8 18.8-43.3 28.1-67.9 28.1-24.6 0-49.1-9.4-67.9-28.1l-117.2-117.2c-37.5-37.5-37.5-98.3 0-135.8l94.8-94.8-86.2-86.2c-6.2-6.3-6.2-16.4 0-22.6l22.6-22.6c6.2-6.3 16.4-6.3 22.6 0l86.2 86.2 81.6-81.6c6.2-6.3 14.4-9.4 22.6-9.4 8.2 0 16.4 3.1 22.6 9.4zM386.4 288l48.3-48.3-162.4-162.4-58.9 59 58.6 58.6c12.5 12.5 12.5 32.8 0 45.2-12.5 12.5-32.8 12.5-45.2 0l-58.6-58.6-81.6 81.6-13.1 13.2c-3.9 3.8-6.1 8-7.4 11.8h320.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fill.js
// module id = 1348
// module chunks = 0